import type { HTMLAttributes, ReactNode } from 'react';
import './Badge.css';

export type BadgeVariant = 'neutral' | 'accent' | 'success' | 'warning' | 'danger';
export type BadgeSize = 'sm' | 'md';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: BadgeVariant;
  size?: BadgeSize;
  /** Иконка слева от текста */
  icon?: ReactNode;
  /** Заливка вместо мягкого фона */
  solid?: boolean;
}

/**
 * Бейдж для статусов и меток. По умолчанию — мягкий фон.
 *
 * @example
 *   <Badge variant="success">OK</Badge>
 *   <Badge variant="danger" icon={<IoAlert />}>Ошибка</Badge>
 *   <Badge variant="accent" solid>3</Badge>
 */
export function Badge({ variant = 'neutral', size = 'md', icon, solid = false, className, children, ...rest }: BadgeProps) {
  const cls = [
    'ds-badge',
    `ds-badge--${variant}`,
    `ds-badge--${size}`,
    solid ? 'ds-badge--solid' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  return (
    <span className={cls} {...rest}>
      {icon && <span className="ds-badge__icon" aria-hidden="true">{icon}</span>}
      {children}
    </span>
  );
}
